<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-06 14:46:57
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="box">
      <template v-if="indexshow == 1">
        <h5>注意：可直接转账和扫码付款，付款成功后一定要上传截图</h5>
        <div class="twobox">
          <div class="left">
            <div class="header">收款信息</div>
            <ul>
              <li>收款银行：{{ infos.bank }}</li>
              <li>收款账户：{{ infos.account }}</li>
              <li>收款账号：{{ infos.accountNum }}</li>
            </ul>
          </div>
          <div class="right">
            <div class="header">收款码</div>
            <ul>
              <div>
                <img :src="infos.path" />
              </div>
            </ul>
          </div>
        </div>
        <!-- <div class="inputs">
          <MyNumberInput :point="2" :max="99999" placeholder="请输入金额" v-model.number="payMoney"></MyNumberInput>
        </div>-->
        <div class="inputs">
          <el-input placeholder="请上传付款截图" v-model="input2">
            <template slot="append">
              <el-upload
                class="upload-demo"
                action
                :show-file-list="false"
                :http-request="myUpload"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </template>
          </el-input>
        </div>
        <div class="buttonbox">
          <el-button type="primary" @click="submint">确定</el-button>
          <el-button>取消</el-button>
        </div>
      </template>
      <div class="shz" v-show="indexshow == 2">
        <img src="@/assets/images/222.png" alt />
        <p>请稍等，管理员正在审核！</p>
      </div>
      <div class="yjf" v-show="indexshow == 3">
        <img src="@/assets/images/111.png" alt />
        <p>
          您已缴费，可点击
          <span @click="jump">缴费查询</span>核实缴费情况！
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/plugins/upload/bus";
import MyNumberInput from "@/components/Plugin/Form/MyNumberInput";
import { upload, pay_to, dueinfo, pay_detail } from "@/api/file"; // 接口导入
export default {
  components: {
    MyNumberInput,
  },
  computed: {},
  data() {
    return {
      input2: "",
      indexshow: 1,
      payMoney: "",
      fileList: [],
      fileUrl: "",
      infos: {},
    };
  },

  created() {},
  mounted() {
    localStorage.setItem("states", 1);
    this.getdueinfo();
    this.selects();
  },
  methods: {
    jump() {
      this.$router.push("/web/payselect");
    },
    //图片上传
    myUpload(params) {
      let formData = new FormData();
      formData.append("file", params.file);
      upload(formData).then((res) => {
        this.input2 = res.data.fileName;
        this.fileUrl = res.data.fileUrl;
      });
    },
    //获取收款码信息
    getdueinfo() {
      dueinfo().then((res) => {
        this.infos = res.data;
      });
    },
    //详情
    selects() {
      let applyId = localStorage.getItem("id");
      pay_detail(applyId).then((res) => {
        if (res.data.payState == 0) {
          this.indexshow = 3;
        } else if (res.data.payState == 1) {
          this.indexshow = 2;
        } else if (res.data.payState == 2) {
          this.indexshow = 1;
        }
      });
    },
    //提交
    submint() {
      let data = {
        applyId: localStorage.getItem("id"),
        payMoney: this.payMoney,
        payPath: this.fileUrl,
      };
      pay_to(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("提交成功");
          let timer = setInterval(() => {
            this.indexshow = 3;
            clearInterval(timer);
            timer = null;
          }, 1000);
        }
      });
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  .box {
    // margin: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    h5 {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #fc524c;
      line-height: 34px;
      text-align: center;
      margin-top: 7vh;
    }
    .inputs {
      margin: 0 auto;
      margin-top: 30px;
      width: 35%;
      input {
        font-size: 14px;
        display: inline-block;
        width: 100%;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
      }
      /deep/ .el-input {
        .el-input-group__append {
          border-left: 0;
          /* background: rgba(22, 122, 252, 1); */
          background: #167afc;
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
          .el-upload-list {
            display: none;
          }
        }
      }
    }
    .shz {
      width: 390px;
      height: 167px;
      margin: auto;
      img {
        width: 390px;
        height: 167px;
      }
      p {
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #838a9d;
        line-height: 34px;
      }
    }
    .yjf {
      width: 390px;
      height: 167px;
      margin: auto;
      img {
        width: 390px;
        height: 167px;
      }
      p {
        text-align: center;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #838a9d;
        line-height: 34px;
        span {
          color: rgba(22, 122, 252, 1);
          cursor: pointer;
        }
      }
    }
    .twobox {
      display: flex;
      justify-content: space-around;
      margin: 0 10%;
      margin-top: 30px;
      .left {
        width: 40%;
        display: flex;
        flex-direction: column;
        // border: 1px solid #24558b;
        // box-shadow: 0px 0px 15px 0px rgba(8, 27, 42, 0.05);
        border-radius: 6px;
        .header {
          width: 100%;
          background: #24558b;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 56px;
          text-indent: 1em;
          border: 1px solid #24558b;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }
        ul {
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          border: 1px solid #24558b;
          padding: 40px 0;
          li {
            margin-top: 30px;
            margin-left: 48px;
            &:first-of-type {
              margin-top: 0;
            }
          }
        }
      }
      .right {
        width: 40%;
        display: flex;
        flex-direction: column;
        border-radius: 6px;
        .header {
          width: 100%;
          background: #24558b;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 56px;
          text-indent: 1em;

          border: 1px solid #24558b;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }
        ul {
          width: 100%;
          border: 1px solid #24558b;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px 0;
          div {
            width: 150px;
            height: 140px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .buttonbox {
      margin: auto;
      margin-top: 30px;
      width: 747px;
      padding-bottom: 30px;
      text-align: center;
      .el-button + .el-button {
        margin-left: 52px;
        padding: 10px 25px;
      }
    }
  }
}
</style>


